import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = {
  class: "w-100",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "day-headline" }
const _hoisted_4 = { class: "day-headline" }
const _hoisted_5 = { class: "day-headline" }
const _hoisted_6 = { class: "day-headline" }
const _hoisted_7 = { class: "day-headline" }
const _hoisted_8 = { class: "day-headline" }
const _hoisted_9 = { class: "day-headline" }
const _hoisted_10 = { class: "day-content" }
const _hoisted_11 = ["onKeyup"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-kalender",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = {
  key: 0,
  role: "dialog",
  "aria-modal": "true",
  class: "timeslot-dialog",
  tabindex: "0"
}
const _hoisted_16 = { class: "d-block d-md-flex align-items-center mb-4" }
const _hoisted_17 = { class: "dialog_label" }
const _hoisted_18 = { class: "ml-auto dialog_label" }
const _hoisted_19 = {
  key: 0,
  class: "row d-flex align-items-center"
}
const _hoisted_20 = { class: "col-6 col-sm-4 col-md-4 mb-2" }
const _hoisted_21 = { class: "timeslot-dialog-name" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "col-6 col-sm-3 col-md-4 mb-2" }
const _hoisted_24 = { class: "bg-lightblue w-100 h-20" }
const _hoisted_25 = { class: "col-12 col-sm-4 col-md-4 text-right text-xs-center mt-2 mt-sm-0 mb-2" }
const _hoisted_26 = { class: "col-12 text-center mt-5 px-0" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "d-flex",
  style: {"height":"100%"}
}
const _hoisted_29 = {
  disabled: "",
  class: "btn w-100 mx-auto pickTerminFull"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-schliesszeiten",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_31 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_time_slot = _resolveComponent("button-time-slot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$t('common.days.MON_SHORT')), 1),
          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('common.days.TUE_SHORT')), 1),
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('common.days.WED_SHORT')), 1),
          _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('common.days.THU_SHORT')), 1),
          _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t('common.days.FRI_SHORT')), 1),
          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('common.days.SAT_SHORT')), 1),
          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t('common.days.SUN_SHORT')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.asWeeks, (week, indexWeek) => {
          return (_openBlock(), _createElementBlock("tr", { key: indexWeek }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day, indexDay) => {
              return (_openBlock(), _createElementBlock("td", {
                key: indexDay,
                class: _normalizeClass(["day", [_ctx.dayCapacityClass(day), _ctx.dayShowAsEmpty(day) ? 'day-capacity-empty' : '']])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(day.dayOfMonth) + " ", 1),
                  _createElementVNode("div", {
                    class: _normalizeClass([ (_ctx.adminDashboard && _ctx.overbooked(day)) ? 'd-block' : 'd-none' , "overbooked"])
                  }, "!", 2),
                  (_ctx.isVisible(day) && (_ctx.adminDashboard || _ctx.dayCapacityClass(day) !== 'day-capacity-full'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "d-flex",
                        onKeyup: _withKeys(($event: any) => (_ctx.closeShow(day.dayOfMonth)), ["esc"]),
                        style: {"height":"100%"}
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.toggleShow(day.dayOfMonth)),
                          class: "btn w-100 mx-auto pickTermin"
                        }, [
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDay(day.timeSlots[0].date)) + " " + _toDisplayString(_ctx.$t('common.timeSlot.srCalendarOpenButton')), 1)
                        ], 8, _hoisted_12),
                        (_ctx.activeItem == day.dayOfMonth && _ctx.showTimeSlot)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('common.timeSlot.availableTime')), 1),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatDay(day.timeSlots[0].date)), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.timeSlots, (timeSlot, timeSlotIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "timeslot-dialog-content mb-4 mt-3",
                                  key: indexDay + '-' + timeSlotIndex
                                }, [
                                  (_ctx.adminDashboard || (timeSlot.capacity > 0 ))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatTime(timeSlot)), 1),
                                          _hoisted_22,
                                          _createTextVNode(" " + _toDisplayString(timeSlot.ticketCount) + " " + _toDisplayString(_ctx.$t('common.from')) + " " + _toDisplayString(timeSlot.capacity) + " " + _toDisplayString(_ctx.$t('common.occupied')) + ". ", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("div", {
                                              class: "bg-darker h-20",
                                              style: _normalizeStyle({ width: _ctx.ticketPercent(timeSlot.ticketCount, timeSlot.capacity) +'%' })
                                            }, null, 4)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          (_ctx.adminDashboard)
                                            ? (_openBlock(), _createBlock(_component_button_time_slot, {
                                                key: 0,
                                                message: _ctx.$t('common.timeSlot.edit'),
                                                onClicked: ($event: any) => (_ctx.$emit('clicked', [_ctx.room.id, timeSlot.id])),
                                                class: _normalizeClass( (timeSlot.capacity < timeSlot.ticketCount) ? 'btn-show-danger' : '' )
                                              }, null, 8, ["message", "onClicked", "class"]))
                                            : (_ctx.ticketPercent(timeSlot.ticketCount, timeSlot.capacity) < 100)
                                              ? (_openBlock(), _createBlock(_component_button_time_slot, {
                                                  key: 1,
                                                  message: _ctx.$t('common.timeSlot.bookTimeslot'),
                                                  onClicked: ($event: any) => (_ctx.$emit('clicked', [_ctx.room.id, timeSlot.id]))
                                                }, null, 8, ["message", "onClicked"]))
                                              : (timeSlot.failedRules.length > 0 && !_ctx.showAusgebucht(day) )
                                                ? (_openBlock(), _createBlock(_component_button_time_slot, {
                                                    key: 2,
                                                    message: _ctx.$t('common.timeSlot.bookTimeslotTempFull'),
                                                    isDisabled: true
                                                  }, null, 8, ["message"]))
                                                : (_openBlock(), _createBlock(_component_button_time_slot, {
                                                    key: 3,
                                                    message: _ctx.$t('common.timeSlot.bookTimeslotFull'),
                                                    isDisabled: true
                                                  }, null, 8, ["message"]))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  class: "btn btn-outline-brand1 btn-xs-w-100 px-5",
                                  onClick: ($event: any) => (_ctx.toggleShow(day.dayOfMonth))
                                }, _toDisplayString(_ctx.$t('common.cancel')), 9, _hoisted_27)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_11))
                    : (_ctx.dayCapacityClass(day) === 'day-capacity-full')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("button", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('common.timeSlot.isFull')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}